var resm_module_panzoom = (function (resm_module_panzoom) {
  resm_module_panzoom.init = function () {
    // var globalRect = {x:218,y:124,width:1309,height:601};

    resm_module_panzoom.panzoom = new Panzoom(
      "#gptw-wrapper .gptw-panzoom-wrapper .gptw-panzoom",
      {
        bound: "inner",
        innerPadding: 20,
        startScale: 1,
        transitionDuration: 400,
        inertiaFriction: 0.85,
        inertiaBounce: 0.2,
        wheel_step: 0.5,
        doubleClickZoom: false,
        doubleClickZoomFitChildren: false,
        doubleClickTime: 250,
        useShiftKey: true,
        useShiftKeyCallbackThrottle: 5000,
        restrictClickToParent: false,
        debug: false,
        dragWhilePinchZooming: true,
        preventSingleTouchDragging: false,
      }
    );

    resm_module_panzoom.panzoom.fitRect(globalRect, 100);

    // use shift overlay
    resm_module_panzoom.panzoom.on("useShiftKey", function (e) {
      useShiftKeyOverlay = $(
        "#gptw-wrapper .gptw-panzoom-wrapper .gptw-use-shift-key-overlay"
      );
      useShiftKeyOverlay.addClass("active");
      setTimeout(function () {
        useShiftKeyOverlay.removeClass("active");
      }, 1000);
    });

    $("#gptw-wrapper .gptw-controls").on(
      "click",
      'a[data-gptw-control="zoom_in"]',
      function (event) {
        event.preventDefault();
        resm_module_panzoom.panzoom.smoothZoomBy(0.4);
      }
    );

    $("#gptw-wrapper .gptw-controls").on(
      "click",
      'a[data-gptw-control="zoom_out"]',
      function (event) {
        event.preventDefault();
        resm_module_panzoom.panzoom.smoothZoomBy(-0.35);
      }
    );

    $("#gptw-wrapper .gptw-controls").on(
      "click",
      'a[data-gptw-control="reset"]',
      function (event) {
        event.preventDefault();
        resm_module_panzoom.panzoom.smoothFitRect(globalRect, {
          top: 100,
          bottom: 50,
          left: 50,
          right: 50,
        });
      }
    );
  };
  return resm_module_panzoom;
})(resm_module_panzoom || {});
